export const TOAST_MESSAGES = {
  MRR_FETCH_FAILED: "Failed to fetch Material Requisitions.",
  MRR_CREATE_FAILED: "Failed to create MRR",
  MRR_UPDATE_FAILED: "Failed to update Material Requisition.",
  MRR_SUCCESS: "MRR created successfully!",
  MRR_ALREADY_ADDED: "This product is already added!",
  MRR_NO_DATA: "No Details Available",
  MRR_DELETE: "MRR Deleted Successfully",
  FAILED_TO_DELETE_MRR: "Failed to delete MRR",
  FAILED_TO_FETCH_WAREHOUSES: "Failed to fetch warehouses!",
  UPDATE_MRR_SUCCESS: "MRR Updated Successfully",
  UPDATE_MRR_FAILED: "Failed to update MRR",
  UPDATE_MRR_STATUS_FAILED: "Failed to update MRR status",
  UPDATE_MRR_STATUS_ERROR: "Error updating status. Please try again.",
  MRR_GRN_FETCH_FAILED: "Error fetching grn-mrr material comparison",
  MRR_DN_FETCH_FAILED: "Error fetching dn-mrr material comparison",
};

export const MATERIAL_COLUMNS = [
  "mrr_code",
  "warehouse_name",
  "estimated_delivery_date",
  "priority",
  "status",
  "created",
  "created_by",
  "actions",
];

export const MATERIAL_LABELS = {
  mrr_code: "MRR Code",
  warehouse_name: "Requested By Site",
  estimated_delivery_date: "Expected Delivery Date",
  priority: "Priority",
  status: "Status",
  created: "Raised On",
  created_by: "Requested By",
  actions: "Actions",
};

export const MRR_STATUS_VALUE_LABELS = [
  { value: "DRAFT", label: "Draft" },
  { value: "PENDING_FOR_APPROVAL", label: "Pending for Approval" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "SENT_TO_INVENTORY", label: "Sent to inventory" },
  { value: "COMPLETED", label: "Completed"
}]

export const MRR_STATUS = {
  DRAFT: "DRAFT",
  PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  SENT_TO_INVENTORY: "SENT_TO_INVENTORY",
  COMPLETED: "COMPLETED",
};

// helper.js or constants.js

export const getMRRStatusColor = (status) => {
  switch (status) {
    case MRR_STATUS.DRAFT:
    return "bg-gray-100 hover:bg-gray-200 transition-colors text-gray-700";
    case MRR_STATUS.PENDING_FOR_APPROVAL:
      return "bg-yellow-50 hover:bg-yellow-150 transition-colors text-yellow-500";
    case MRR_STATUS.APPROVED:
      return "bg-green-50 hover:bg-green-150 transition-colors text-green-500";
    case MRR_STATUS.REJECTED:
      return "bg-red-50 hover:bg-red-150 transition-colors text-red-500";
    case MRR_STATUS.SENT_TO_INVENTORY:
      return "bg-purple-50 hover:bg-purple-150 transition-colors text-purple-500";
    case MRR_STATUS.COMPLETED:
      return "bg-blue-50 hover:bg-blue-150 transition-colors text-blue-500";
    default:
      return "bg-white transition-colors text-black"; // fallback for unknown status
  }
};

export const MATERIAL_COLUMNS_MRR = ["product_name", "quantity", "description", "actions"];
export const MATERIAL_LABELS_MRR = {
  product_name: "Material",
  description: "Delivery Note",
  quantity: "Quantity",
  actions: "Action",
};

export const materialColumns = [
  "product_name",
  "quantity",
  "description"
];

export const materialLabels = {
  product_name: "Material",
  quantity: "Quantity",
  description: "Description",
};

export const product_grn_mrr_Columns = [
  "product_name",
  "requested_qty",
  "received_qty",
  "damaged_goods_qty",
  "remaining_qty",
]
export const product_grn_mrr_Labels = {
  product_name: "Product",
  requested_qty: "Requested Quantity",
  received_qty: "Received Quantity",
  damaged_goods_qty: "Damaged Quantity",
  remaining_qty: "Remaining Quantity",
}

export const dispatchColumns = [
  "product_name",
  "requested_quantity",
  "total_dispatched_quantity",
  "remaining_quantity"
]

export const dispatchLabels = {
  product_name: "Product",
  requested_quantity: "Requested Quantity",
  total_dispatched_quantity: "Dispatched Quantity",
  remaining_quantity: "Remaining Quantity",
}

export const STATUS_COLORS = {
  DRAFT: "bg-gray-100 text-gray-800",
  PENDING_FOR_APPROVAL: "bg-yellow-100 text-yellow-800",
  APPROVED: "bg-green-100 text-green-800",
  REJECTED: "bg-red-100 text-red-800",
};

export const TABS = {
  DETAILS: "details",
  GRN: "grn",
  DN: "dn",
};